const EVENT_TRACK_NAME_MAP = {
    'CLICK_INDEX_CALENDAR': '点击_套餐_套餐团期_选择套餐',
    'CLICK_INDEX_COMMENT': '点击_点评_点评_查看点评详情',
    'CLICK_INDEX_JOURNEY_TAB': '点击_行程_行程栏_切换行程',
    'CLICK_INDEX_NOTICE': '点击_产品详情_预订须知_查看预订须知',
    'CLICK_INDEX_POLICY': '点击_产品详情_退改规则_查看退改规则',
    'CLICK_INDEX_RECOMMEND': '点击_产品详情页_卖家推荐_点击产品',
    'SCROLL_INDEX_RECOMMEND': '点击_产品详情页_卖家推荐_右滑拓展',
    'CLICK_INDEX_SHOP': '点击_店铺_查看店铺',
    'CLICK_INDEX_BOTTOM_COLLECT': '点击_底部按钮_收藏_收藏产品',
    'CLICK_INDEX_SERVICE_TEL': '点击_客服详情_电话客服_选择电话客服',
    'CLICK_INDEX_BOTTOM_SUBMIT': '点击_底部按钮_立即预订_立即预订',
    'CLICK_INDEX_POPUP_SUBMIT': '点击_底部按钮_套餐选择层_立即购买',
    'CLICK_PKG_PKG': '点击_套餐_选择套餐',
    'CLICK_PKG_CALENDAR': '点击_团期_选择团期',
    'CLICK_PKG_SUBMIT': '点击_底部按钮_填写订单_下一步填写订单',
    'CLICK_BOOK_SUBMIT': '点击_底部_提交订单_提交订单',
    'CLICK_BOOK_ADD_TROUIST': '点击_出游人_添加_添加出游人',
    'CLICK_BOOK_DELETE_TROUIST': '点击_出游人_删除_删除出游人',
    'CLICK_INDEX_MOREPLANE': '点击_产品详情页机票推荐_特价机票',
    'CLICK_INDEX_PLANELIST':'点击_产品详情页机票推荐_机票列表'
}

/**
 * 打点统计代码
 * @see http://analy.tuniu.cn/analysisCollect/tac.mini.js
 */
let tracker;

function getTrack() {
    if (tracker) {
        return tracker;
    } else {
        if (window.eventTrack &&
            window.eventTrack.push &&
            typeof window.eventTrack.push === 'function') {
            tracker = window.eventTrack;
            return tracker;
        }
    }
}

function getEventTrackName(eventTrackType) {
    if(EVENT_TRACK_NAME_MAP.hasOwnProperty(eventTrackType)) {
        return EVENT_TRACK_NAME_MAP[eventTrackType];
    }else {
        return eventTrackType;
    }
}

/**
 * 事件打点
 * @param  {String} eventTrackType 事件打点类型
 * @param  {[type]} e   event对象
 */
export function eventTrack(eventTrackType, e) {
    let tracker = getTrack();
    let trackName = getEventTrackName(eventTrackType);
    if (tracker && trackName) {
        tracker.push({
            text: trackName,
            x: e && e.clientX,
            y: e && e.clientY
        });
    }
}

/**
 * 页面打点
 * @return {Array} data
 */
export function pageTrack(data) {
    if (Array.isArray(data)) {
        window.pageName = data.join(':');
        if (window.COLLECT) {
            window.COLLECT('', data.join(':'), '', data.join('/'));
        }
        if (window.FTA) {
            window.FTA('', data.join(':'), '', data.join('/'));
        }
    }
}



// WEBPACK FOOTER //
// libs/business/analy.js